<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card text-xs-center class="py-4">
      <v-card-text text-xs-center class="align-center px-4 pt-0 pb-0">
        <v-icon v-if="typeSuccess" color="rgb(84,110,122)" size="60"
          >check_circle_outline</v-icon
        >
        <v-icon v-else color="red" size="80">highlight_off</v-icon>
        <p class="my-3 status-title">{{ messageTitle | translate }}</p>
        <p class="my-3">{{ messageText | translate }}</p>
      </v-card-text>
      <v-card-actions>
        <v-layout row wrap justify-end>
          <v-flex xs12 text-xs-center class="pr-2">
            <v-btn @click="goToButton" color="primary" class="btn-width">{{
              OkButtonText | translate
            }}</v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TechAccessDialog",
  data() {
    return {
      dialog: false
    };
  },
  props: {
    messageText: {
      type: String,
      default: "lng_smith_warning"
    },
    openDialog: {
      type: Boolean,
      default: false
    },
    closeDialog: {
      type: Function,
      default: undefined
    },
    translate: {
      type: Boolean,
      default: true
    },
    messageTitle: {
      type: String,
      default: ""
    },
    OkButtonText: {
      type: String,
      default: "lng_ok"
    },
    typeSuccess: {
      type: Boolean,
      default: true
    },
    goToButton: {
      type: Function,
      default: undefined
    }
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
    }
  }
};
</script>
<style scoped>
.def-btn {
  color: rgb(84, 110, 122);
}
.md-title {
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.005em;
}
.align-center {
  text-align: center;
}
.status-title {
  color: rgb(84, 110, 122);
  font-size: 24px;
  font-weight: 500;
}
.btn-width {
  min-width: 200px;
}
</style>
